import { render, staticRenderFns } from "./ViewEmailTemplate.vue?vue&type=template&id=d38257b8&scoped=true"
import script from "./ViewEmailTemplate.vue?vue&type=script&lang=js"
export * from "./ViewEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewEmailTemplate.vue?vue&type=style&index=0&id=d38257b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38257b8",
  null
  
)

export default component.exports